import Footer from "../../components/Footer";
import Header from "../../components/Header";
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";
import EVCSDeployment from "../../components/Service/Subservice/turnkey-evcs";

export default function TurnkeyEVCS() {
    return (
        <>
        <Header/>
        <SubServiceBanner title={"TurnKey EVCS Deployment"}/>
        <EVCSDeployment/>
        <Footer/>
        </>
       
    )
}